import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Truck, RefreshCw, HeartHandshake, Sparkles, ArrowRight, Instagram, Star } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { toast } from "sonner";

const INSTA_IMAGES = [
  "https://images.unsplash.com/photo-1596461010414-1a97e14bd0d3?w=400&q=80",
  "https://images.unsplash.com/photo-1611403119860-57c4937ef987?w=400&q=80",
  "https://images.unsplash.com/photo-1591561954557-26941169b49e?w=400&q=80",
  "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400&q=80",
  "https://images.unsplash.com/photo-1526512340740-9217d0159da9?w=400&q=80",
  "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?w=400&q=80",
];

const TESTIMONIALS = [
  { name: "Juliana M.", city: "Recife, PE", text: "Comprei o kit maternidade e me apaixonei! Qualidade impecável, acabamento delicado. Minha filha ficou linda.", rating: 5 },
  { name: "Maria Clara", city: "São Paulo, SP", text: "Os laços são lindos e muito bem feitos. Chegou rapidinho, muito bem embalado. Super recomendo!", rating: 5 },
  { name: "Camila S.", city: "Fortaleza, CE", text: "Já é a terceira compra que faço. Serviço impecável e as peças são cada uma mais fofa que a outra.", rating: 5 },
];

export default function Home() {
  const [settings, setSettings] = useState({});
  const [cats, setCats] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [newArr, setNewArr] = useState([]);
  const [kits, setKits] = useState([]);
  const [heroIdx, setHeroIdx] = useState(0);
  const [email, setEmail] = useState("");

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {}));
    api.get("/categories").then((r) => setCats(r.data));
    api.get("/products", { params: { bestseller: true, limit: 8 } }).then((r) => setBestSellers(r.data.items));
    api.get("/products", { params: { sort: "newest", limit: 8 } }).then((r) => setNewArr(r.data.items));
    api.get("/products", { params: { category: "kits-presente", limit: 4 } }).then((r) => setKits(r.data.items));
  }, []);

  useEffect(() => {
    const banners = settings.hero_banners || [];
    if (banners.length < 2) return;
    const t = setInterval(() => setHeroIdx((i) => (i + 1) % banners.length), 6000);
    return () => clearInterval(t);
  }, [settings]);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/newsletter", { email, source: "landing" });
      toast.success(`Pronto! Use o cupom ${data.coupon} para 10% OFF na primeira compra 💗`);
      setEmail("");
    } catch (err) {
      toast.error("Não foi possível cadastrar seu e-mail");
    }
  };

  const banners = settings.hero_banners || [];
  const hero = banners[heroIdx] || { title: "Detalhes que fazem sua pequena brilhar", subtitle: "Acessórios infantis feitos com carinho.", cta_text: "Ver coleção", cta_link: "/categoria/lacos" };

  return (
    <div>
      {/* Hero */}
      <section className="relative overflow-hidden" data-testid="hero-section">
        <div className="max-w-7xl mx-auto px-4 py-8 md:py-14 grid md:grid-cols-2 gap-8 items-center">
          <div className="fade-in-up">
            <span className="inline-flex items-center gap-1.5 bg-[#F9E1E8] text-[#C9708B] border-2 border-dashed border-[#E8A0B4] px-4 py-1.5 rounded-full text-xs font-bold tracking-wider mb-5">
              <Sparkles className="w-3.5 h-3.5" /> Novidades da semana
            </span>
            <h1 className="font-serif font-bold text-[#4A3B40] text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
              {hero.title}
            </h1>
            <p className="mt-5 text-[#8C7A80] text-base sm:text-lg leading-relaxed max-w-lg">
              {hero.subtitle}
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to={hero.cta_link || "/categoria/lacos"} className="btn-lara" data-testid="hero-cta-primary">
                {hero.cta_text || "Ver coleção"} <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/categoria/kits-presente" className="btn-lara-outline" data-testid="hero-cta-secondary">
                Kits presente
              </Link>
            </div>
            <div className="mt-6 flex items-center gap-4 text-xs text-[#8C7A80]">
              <div className="flex -space-x-2">
                {["JL","MC","CS","AF"].map((n, i) => (
                  <div key={i} className="w-8 h-8 rounded-full bg-[#F9E1E8] border-2 border-white text-[#C9708B] text-[10px] font-bold flex items-center justify-center">{n}</div>
                ))}
              </div>
              <span>+2.800 mamães encantadas 💗</span>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#F9E1E8] rounded-full blur-3xl opacity-70" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-[#E8A0B4]/50 rounded-full blur-3xl" />
            <div className="relative rounded-3xl overflow-hidden stitch-border bg-[#F9E1E8] aspect-[4/5] shadow-xl">
              <img src={hero.image || "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=1200&q=85"} alt="" className="w-full h-full object-cover" />
            </div>
            {banners.length > 1 && (
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5">
                {banners.map((_, i) => (
                  <button key={i} onClick={() => setHeroIdx(i)} className={`h-2 rounded-full transition-all ${i===heroIdx ? 'bg-[#C9708B] w-6' : 'bg-white/80 w-2'}`} />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="bg-white border-y border-[#F9E1E8]">
        <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            {icon: Truck, title: "Envio para todo Brasil", sub: "Frete grátis acima de R$ 199"},
            {icon: ShieldCheck, title: "Compra segura", sub: "Ambiente 100% protegido"},
            {icon: Sparkles, title: "5% OFF no PIX", sub: "Desconto automático"},
            {icon: RefreshCw, title: "Troca fácil", sub: "Até 7 dias para trocar"},
          ].map((b, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-[#F9E1E8] text-[#C9708B] flex items-center justify-center shrink-0"><b.icon className="w-5 h-5" /></div>
              <div>
                <p className="font-semibold text-[#4A3B40] text-sm">{b.title}</p>
                <p className="text-xs text-[#8C7A80]">{b.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Categorias em destaque */}
      <section className="max-w-7xl mx-auto px-4 py-14">
        <div className="text-center mb-10">
          <h2 className="font-serif font-semibold text-[#4A3B40] text-3xl sm:text-4xl">Categorias em destaque</h2>
          <p className="text-[#8C7A80] mt-2">Explore nossas coleções favoritas</p>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
          {cats.map((c) => (
            <Link key={c.id} to={`/categoria/${c.slug}`} className="group text-center" data-testid={`cat-tile-${c.slug}`}>
              <div className="aspect-square rounded-full overflow-hidden border-2 border-dashed border-[#E8A0B4] p-1 bg-[#FFF9FA] group-hover:scale-105 transition-transform">
                <img src={c.image || "https://placehold.co/200x200/F9E1E8/C9708B?text=L"} alt={c.name} className="w-full h-full object-cover rounded-full" />
              </div>
              <p className="mt-3 font-serif font-medium text-sm text-[#4A3B40] group-hover:text-[#C9708B] transition-colors">{c.name}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* Mais vendidos */}
      <section className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-serif font-semibold text-[#4A3B40] text-2xl sm:text-3xl">Mais vendidos</h2>
            <p className="text-[#8C7A80] text-sm">Os queridinhos das mamães</p>
          </div>
          <Link to="/busca" className="text-sm font-semibold text-[#C9708B] hover:underline hidden sm:inline">Ver todos →</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {bestSellers.map((p) => <ProductCard key={p.id} product={p} testIdPrefix="bestseller" />)}
        </div>
      </section>

      {/* Banner coleção */}
      <section className="max-w-7xl mx-auto px-4 py-10">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-[#F9E1E8] via-[#FFF9FA] to-[#F9E1E8] p-8 md:p-14 grid md:grid-cols-2 gap-6 items-center stitch-border">
          <div>
            <span className="bg-[#D4B483] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">Edição Limitada</span>
            <h3 className="font-serif font-bold text-3xl sm:text-4xl text-[#4A3B40] mt-4">Coleção Primavera Encantada</h3>
            <p className="text-[#8C7A80] mt-3 max-w-md">Peças únicas inspiradas na delicadeza das flores. Produção artesanal e materiais premium.</p>
            <Link to="/categoria/tiaras" className="btn-lara mt-5 inline-flex">Explorar coleção <ArrowRight className="w-4 h-4" /></Link>
          </div>
          <div className="rounded-2xl overflow-hidden aspect-[4/3]">
            <img src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&q=85" alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {/* Novidades */}
      <section className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-serif font-semibold text-[#4A3B40] text-2xl sm:text-3xl">Novidades</h2>
            <p className="text-[#8C7A80] text-sm">Acabou de chegar na loja</p>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {newArr.map((p) => <ProductCard key={p.id} product={p} testIdPrefix="newarr" />)}
        </div>
      </section>

      {/* Kits presente */}
      <section className="bg-[#F9E1E8]/40 py-14 mt-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="inline-block bg-[#F9E1E8] text-[#C9708B] border-2 border-dashed border-[#E8A0B4] px-4 py-1.5 rounded-full text-xs font-bold tracking-wider">Especiais</span>
            <h2 className="font-serif font-bold text-[#4A3B40] text-3xl sm:text-4xl mt-3">Kits presente encantadores</h2>
            <p className="text-[#8C7A80] mt-2">O presente perfeito para chás de bebê e aniversários</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {kits.map((p) => <ProductCard key={p.id} product={p} testIdPrefix="kit" />)}
          </div>
        </div>
      </section>

      {/* Sobre */}
      <section className="max-w-7xl mx-auto px-4 py-14 grid md:grid-cols-2 gap-10 items-center">
        <div className="relative">
          <div className="rounded-3xl overflow-hidden stitch-border aspect-[4/5]">
            <img src="https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=800&q=85" alt="" className="w-full h-full object-cover" />
          </div>
        </div>
        <div>
          <span className="inline-block bg-[#F9E1E8] text-[#C9708B] px-3 py-1 rounded-full text-xs font-bold">Nossa história</span>
          <h2 className="font-serif font-bold text-[#4A3B40] text-3xl sm:text-4xl mt-3">Feito com carinho em cada detalhe</h2>
          <p className="text-[#8C7A80] mt-4 leading-relaxed">
            {settings.about_text || "A Lara B. nasceu do carinho e da vontade de criar acessórios únicos para as pequenas princesas."}
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4 text-center">
            <div><p className="font-serif text-3xl text-[#C9708B] font-bold">+2.800</p><p className="text-xs text-[#8C7A80]">Clientes felizes</p></div>
            <div><p className="font-serif text-3xl text-[#C9708B] font-bold">100%</p><p className="text-xs text-[#8C7A80]">Artesanal</p></div>
            <div><p className="font-serif text-3xl text-[#C9708B] font-bold">4,9</p><p className="text-xs text-[#8C7A80]">⭐ Avaliação</p></div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section className="bg-white border-y border-[#F9E1E8] py-14">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="font-serif font-bold text-[#4A3B40] text-3xl">O que as mamães dizem</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <div key={i} className="bg-[#FFF9FA] rounded-2xl p-6 border border-[#F9E1E8]" data-testid={`testimonial-${i}`}>
                <div className="flex gap-0.5 mb-3">
                  {Array.from({length: t.rating}).map((_, j) => <Star key={j} className="w-4 h-4 fill-[#D4B483] text-[#D4B483]" />)}
                </div>
                <p className="text-[#4A3B40] italic leading-relaxed">"{t.text}"</p>
                <div className="mt-4">
                  <p className="font-semibold text-[#4A3B40] text-sm">{t.name}</p>
                  <p className="text-xs text-[#8C7A80]">{t.city}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram */}
      <section className="max-w-7xl mx-auto px-4 py-14 text-center">
        <h2 className="font-serif font-bold text-[#4A3B40] text-3xl flex items-center justify-center gap-2">
          <Instagram className="w-6 h-6" /> {settings.instagram || "@lojalarab"}
        </h2>
        <p className="text-[#8C7A80] mt-2">Siga a #MundoLaraB</p>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 mt-8">
          {INSTA_IMAGES.map((src, i) => (
            <a key={i} href="#" className="aspect-square rounded-xl overflow-hidden group relative">
              <img src={src} alt="" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-[#C9708B]/0 group-hover:bg-[#C9708B]/40 flex items-center justify-center transition">
                <Instagram className="w-5 h-5 text-white opacity-0 group-hover:opacity-100" />
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Newsletter */}
      <section className="max-w-5xl mx-auto px-4 py-10">
        <div className="rounded-3xl bg-[#C9708B] text-white p-10 md:p-14 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10" style={{backgroundImage:"radial-gradient(circle at 20% 20%, white 2px, transparent 3px)",backgroundSize:"24px 24px"}} />
          <div className="relative">
            <h3 className="font-serif font-bold text-3xl sm:text-4xl">Ganhe 10% OFF na primeira compra</h3>
            <p className="mt-3 text-white/80">Cadastre seu e-mail e receba cupons exclusivos</p>
            <form onSubmit={subscribe} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                required
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                placeholder="seu@email.com.br"
                className="flex-1 rounded-full px-5 py-3 text-[#4A3B40] placeholder:text-[#8C7A80] outline-none"
                data-testid="newsletter-email-input"
              />
              <button className="bg-white text-[#C9708B] font-bold rounded-full px-6 py-3 hover:bg-[#F9E1E8] transition-colors" data-testid="newsletter-submit">
                Receber cupom
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
